import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import ClientesInfo from "./ClientesInfo";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import DatosAdicionalesCliente, { EXTRA_CLIENTE_VACIO, extraDeCliente, extraParaGuardar, ContactosEditor, contactosParaGuardar } from "./DatosAdicionalesCliente";
import { puede } from "../../../../permisos/permisos";

function ListadoClientes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_BONIFICACIONES_RECURRENTES = process.env.REACT_APP_URL_BONIFICACIONES_RECURRENTES;
  const URL_CONCEPTOS_BONIFICACIONES = process.env.REACT_APP_URL_CONCEPTOS_BONIFICACIONES;
  const URL_CUENTAS_CLIENTES = process.env.REACT_APP_URL_CUENTAS_CLIENTES;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;

  const [clientes, setClientes] = useState([]);
  const [clienteEdit, setClienteEdit] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");
  const [idPassword, setIdPassword] = useState("");
  const [idEditCliente, setIdEditCliente] = useState("");
  const [selectedGrupoEdit, setSelectedGrupoEdit] = useState("");
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("");
  const [RFC, setRFC] = useState("");
  const [calle, setCalle] = useState("");
  const [numero_ext, setNumeroExt] = useState("");
  const [numero_int, setNumeroInt] = useState("");
  const [delegacion, setDelegacion] = useState("");
  const [estado, setEstado] = useState("");
  const [pais, setPais] = useState("");
  const [cp, setCP] = useState("");
  const [colonia, setColonia] = useState("");
  const [codigo, setCodigo] = useState("");
  const [comprador, setComprador] = useState("");
  const [fiscal, setFiscal] = useState("Si");
  // Vista del catalogo: "Si" = Kasher, "No" = Taref, "" = todos.
  const [vistaFiscal, setVistaFiscal] = useState("Si");
  // Taref solo con permiso especial: sin el, solo se ve Kasher (ni selector, ni exportaciones).
  const verTaref = puede(user, "catalogos.clientes.taref");
  const vistaEfectiva = verTaref ? vistaFiscal : "Si";
  const [ciudad, setCiudad] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [emailViejo, setEmailViejo] = useState("");
  const [idInfo, setIdInfo] = useState("");
  const [plazo, setPlazo] = useState("");
  const [frecuenciaCompra, setFrecuenciaCompra] = useState(0);
  const [extra, setExtra] = useState(EXTRA_CLIENTE_VACIO);
  const [selectedContacto, setSelectedContacto] = useState("");
  const [selectedContactoName, setSelectedContactoName] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [ultimo_pago, setUltimoPago] = useState("");
  const [forma_pago, setFormaPago] = useState("");  
  const [regFiscal, setRegFiscal] = useState("");
  const [usoCFDI, setusoCFDI] = useState("");
  const [formaPagoSAT, setFormaPagoSAT] = useState("");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("");
  const [selected_grupo_name, setSelectedGrupoName] = useState("");
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [cuentas, setCuentas] = useState([]);
  const [idClienteCuenta, setIdClienteCuenta] = useState("");

  const [modalCuenta, setModalCuenta] = useState(false);
  const toggleCuenta = () => setModalCuenta(!modalCuenta);

  const [activo, setActivo] = useState("");
  const [contacto, setContacto] = useState("");
  const [grupo, setGrupo] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalBoni, setModalBoni] = useState(false);
  const toggleBoni = () => setModalBoni(!modalBoni);
  const [conceptosBonificaciones, setConceptosBonificaciones] = useState([]);
  const [boniCliente, setBoniCliente] = useState([]);
  const [idClienteBoni, setIdClienteBoni] = useState("");
  const [clienteBoniName, setClienteBoniName] = useState("");

   // Direcciones Sucursal
   const [sucursales, setSucursales] = useState([]);
   const [idClienteSucursal, setIdClienteSucursal] = useState("");
   const [modalSucursal, setModalSucursal] = useState(false);
   const toggleSucursal = () => setModalSucursal(!modalSucursal);
 
   const [abrirSucursal, setAbrirSucursal] = useState(false);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      fecha:"",
      concepto: "",
      fijo:"",
      porcentaje: 0,
      importe: 0,
      observaciones: "NA",
      },
  ]);

  const [inputFieldsCuentas, setInputFieldsCuentas] = useState([
    {
      id: uuidv4(),
      banco: "",
      cuenta:"",
    },
  ]);

  const [inputFieldsSuc, setInputFieldsSuc] = useState([
    {
      id: uuidv4(),
      alias: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      delegacion: "",
      estado: "",
      pais: "",
      cp: "",
      colonia: "",
      ciudad: "",
      RFC:"",
      razon_social:"",
      regFiscal: "",
      contactos: []
    },
  ]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        // Array para pagination
        let arrayTabla = allClientes
          // Por numeracion (codigo consecutivo).
          .sort((a, b) => (parseInt(a.codigo, 10) || 0) - (parseInt(b.codigo, 10) || 0))
          .map((a) => {
            return {
              _id: a._id,
              activo: a.is_active,
              telefono: a.telefono,
              email: a.email,
              calle: a.calle,
              numero_ext: a.numero_ext,
              numero_int: a.numero_int,
              pais: a.pais,
              estado: a.estado,
              ciudad: a.ciudad,
              delegacion: a.delegacion,
              colonia: a.colonia,
              codigo: a.codigo,
              comprador: a.comprador || "",
              fiscal: a.fiscal || "Si",
              cp: a.cp,
              nombre_comercial: a.nombre_comercial,
              razon_social: a.razon_social,
              RFC: a.RFC,
              grupo: a.grupos?.[0]?.name || "NA",
              idGrupo: a.grupos?.[0]?._id || "",
              contacto: a.contacto?.[0]
                ? `${a.contacto[0].nombre} ${a.contacto[0].apellido || ""}`
                : "NA",
              idContacto: a.contacto?.[0]?._id || "",
              observaciones: a.observaciones,
              ultimo_pago: a.ultimo_pago,
              forma_pago: a.forma_pago,
              plazo: a.plazo,
              frecuenciaCompra: a.frecuenciaCompra || 0,
              extra: extraDeCliente(a),
              regFiscal: a.regFiscal,
              usoCFDI: a.usoCFDI,
              formaPagoSAT: a.formaPagoSAT,
              condicionesPagoSAT: a.condicionesPagoSAT,
              metodoPagoSAT: a.metodoPagoSAT,
              ultimoPedido: a.ultimoPedido,
              ultimoSurtido: a.ultimoSurtido,
              ultimaLlamada: a.ultimaLlamada,
              proximaLlamada: a.proximaLlamada,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setClientes(allClientes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allGrupos = response.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS_BONIFICACIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allConceptosBonificaciones = response.data;
        setConceptosBonificaciones(allConceptosBonificaciones);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const ListaClientes = clientes
    .filter((c) => !vistaEfectiva || (c.fiscal || "Si") === vistaEfectiva)
    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1));

  function PDFTabla() {
    const data = ListaClientes.map((a) => {
      if (
        (grupo == 0 || grupo == a.grupos[0]._id) &&
        (contacto == 0 || contacto == a.contacto[0]._id) &&
        (activo == 0 || activo == a.is_active)
      ) {
        return [
          a.nombre_comercial,
          a.telefono,
          a.email,
          a.grupos[0].name,
          [a.contacto[0].nombre + " " + a.contacto[0].apellido],
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Clientes`, 20, 40);
    doc.autoTable({
      head: [["Nombre", "Telefono", "Mail", "Zona", "Contacto"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Clientes.pdf`);
  }

  function excel() {
    const dataExcel = ListaClientes.map((a) => {
      if (
        (grupo == 0 || grupo == a.grupos[0]._id) &&
        (contacto == 0 || contacto == a.contacto[0]._id) &&
        (activo == 0 || activo == a.is_active)
      ) {
        return {
          Nombre: a.nombre_comercial,
          Telefono: a.telefono,
          Mail: a.email,
          Zona: a.grupos[0].name,
          Contacto: [a.contacto[0].nombre + " " + a.contacto[0].apellido],
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoClientes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoClientes",
        sheetFilter: ["Nombre", "Telefono", "Mail", "Zona", "Contacto"],
        sheetHeader: ["Nombre", "Telefono", "Mail", "Zona", "Contacto"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaClientes.map((a) => {
      if (
        (grupo == 0 || grupo == a.grupos[0]._id) &&
        (contacto == 0 || contacto == a.contacto[0]._id) &&
        (activo == 0 || activo == a.is_active)
      ) {
        return [
          a.nombre_comercial,
          a.telefono,
          a.email,
          a.grupos[0].name,
          [a.contacto[0].nombre + " " + a.contacto[0].apellido],
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Clientes`, 20, 40);
    doc.autoTable({
      head: [["Nombre", "Telefono", "Mail", "Zona", "Contacto"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Clientes",
          email: mailTo,
          fileName: "ListadoClientes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Clientes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    idEdit,
    telefono,
    email,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    nombre_comercial,
    razon_social,
    RFC,
    gruposName,
    gruposId,
    contactoNombre,
    contactoId,
    observaciones,
    ultimo_pago,
    forma_pago,
    usoCFDI, 
    regFiscal, 
    formaPagoSAT,
    condicionesPagoSAT,
    metodoPagoSAT,
    codigo,
    plazo,
    frecuenciaCompra,
    comprador,
  ) {
    setTelefono(telefono);
    setEmail(email);
    setEmailViejo(email);
    setCalle(calle);
    setNumeroExt(numero_ext);
    setNumeroInt(numero_int);
    setPais(pais);
    setEstado(estado);
    setCiudad(ciudad);
    setDelegacion(delegacion);
    setColonia(colonia);
    setCP(cp);
    setNombreComercial(nombre_comercial);
    setRazonSocial(razon_social);
    setRFC(RFC);
    setSelectedGrupoName(gruposName);
    setSelectedGrupoEdit(gruposId);
    setSelectedContactoName(contactoNombre);
    setSelectedContacto(contactoId);
    setObservaciones(observaciones);
    setUltimoPago(ultimo_pago);
    setFormaPago(forma_pago);
    setusoCFDI(usoCFDI)
    setRegFiscal(regFiscal)
    setFormaPagoSAT(formaPagoSAT);
    setCondicionesPagoSAT(condicionesPagoSAT);
    setMetodoPagoSAT(metodoPagoSAT);
    setCodigo(codigo);
    setIdEditCliente(idEdit);
    setPlazo(plazo);
    setFrecuenciaCompra(frecuenciaCompra || 0);
    setComprador(comprador === "NA" ? "" : (comprador || ""));
    toggleEdit();
  }

  function Info(id) {
    setIdInfo(id);
    toggle();
  }

  // Ticket 3: guarda última/próxima llamada editada en línea desde el listado
  function guardaLlamada(idCliente, campo, valor) {
    axios
      .patch(
        `${URL_CLIENTES}/${idCliente}`,
        { [campo]: valor },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Guardado",
          showConfirmButton: false,
          timer: 800,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo guardar",
        });
        console.log(error);
      });
  }

  function editClientes(event) {
    event.preventDefault();
    const URL_CLIENTES_EDIT = `${process.env.REACT_APP_URL_CLIENTES}/${idEditCliente}`;

        axios.patch(
          URL_CLIENTES_EDIT,
          {
            nombre_comercial,
            razon_social,
            RFC,
            calle,
            numero_ext,
            numero_int,
            delegacion,
            estado,
            pais,
            cp,
            colonia,
            ciudad,
            telefono,
            email,
            ...(selectedGrupoEdit && selectedGrupoEdit != "0" ? { grupos: selectedGrupoEdit } : {}),
            ...(selectedContacto && selectedContacto != "0" ? { contacto: selectedContacto } : {}),
            observaciones,
            ultimo_pago,
            forma_pago,
            usoCFDI,
            regFiscal,
            formaPagoSAT,
            condicionesPagoSAT,
            metodoPagoSAT,
            comprador: comprador || "NA",
            fiscal,
            plazo,
            frecuenciaCompra: Number(frecuenciaCompra) || 0,
            ...extraParaGuardar(extra),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cliente",
            detalle: `${nombre_comercial}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Telefono", field: "telefono", sortable: false },
    { name: "Email", field: "email", sortable: true },
    { name: "Zona", field: "grupo", sortable: true },
    { name: "Contacto", field: "contacto", sortable: true },
    { name: "Ult. Pedido", field: "ultimoPedido", sortable: true },
    { name: "Ult. Surtido", field: "ultimoSurtido", sortable: true },
    { name: "Ult. Llamada", field: "ultimaLlamada", sortable: false },
    { name: "Prox. Llamada", field: "proximaLlamada", sortable: false },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre_comercial
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.email.toLowerCase().includes(search.toLowerCase()) ||
          comment.grupo.toLowerCase().includes(search.toLowerCase()) ||
          (comment.codigo || "").toLowerCase().includes(search.toLowerCase()) ||
          comment.contacto.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (grupo) {
      computedComments = computedComments.filter((e) =>
        e.idGrupo.includes(grupo)
      );
    }
    if (contacto) {
      computedComments = computedComments.filter((e) =>
        e.idContacto.includes(contacto)
      );
    }
    if (vistaEfectiva) {
      computedComments = computedComments.filter((e) => e.fiscal === vistaEfectiva);
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      // numeric: true para que "10" vaya despues de "9" (codigos/claves).
      computedComments = [...computedComments].sort(
        (a, b) =>
          reversed *
          String(a[sorting.field] ?? "").localeCompare(String(b[sorting.field] ?? ""), "es", { numeric: true })
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, contacto, grupo, activo, vistaEfectiva]);


  function jalaBoni(id, name){
    setIdClienteBoni(id)
    setClienteBoniName(name)

    axios
      .get(`${URL_BONIFICACIONES_RECURRENTES}Cliente/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBoniCliente = response.data;
       let arrayTabla =  allBoniCliente.map((a)=>{
          return{
            id: a._id,
            fecha: a.fecha,
            concepto: a.conceptosBonificaciones[0]._id,
            fijo: a.fijo,
            porcentaje: a.porcentaje,
            importe: a.importe,
            observaciones: a.observaciones,
            is_active: a.is_active
          }
        })
        .filter(function (el) {
          return el != null;
        });

      let dataFinal = Object.values(arrayTabla);
        setBoniCliente(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

      toggleBoni()
  }


  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputExistentes = (id, event) => {
    const newBoniCliente = boniCliente.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setBoniCliente(newBoniCliente);
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        fecha:"",
        concepto: "",
        fijo:"",
        porcentaje: 0,
        importe: 0,
        observaciones: "NA",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
  };

  function saveBoni() {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará la bonificacion",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        toggleProgreso();
        let totalMails = inputFields.length + boniCliente.length

        inputFields.map((a) => {
          if (a.porcentaje > 0 || a.importe > 0) {
            axios
              .post(
                URL_BONIFICACIONES_RECURRENTES,
                {
                  fecha: a.fecha,
                  importe: a.importe,
                  porcentaje: a.porcentaje,
                  clientes: idClienteBoni,
                  conceptosBonificaciones: a.concepto,
                  observaciones: a.observaciones,
                  fijo: a.fijo
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
               totalMails = totalMails - 1;
                if (totalMails == 0) {

                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                 
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  // footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            totalMails = totalMails - 1;
          }
        })

        boniCliente.map((a) => {
            axios
              .patch(
                `${URL_BONIFICACIONES_RECURRENTES}/${a.id}`,
                {
                  fecha: a.fecha,
                  importe: a.importe,
                  porcentaje: a.porcentaje,
                  conceptosBonificaciones: a.concepto,
                  observaciones: a.observaciones,
                  fijo: a.fijo
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
               totalMails = totalMails - 1;
                if (totalMails == 0) {

                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                 
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  // footer: `${error.response.data}`,
                });
                console.log(error);
              });
        });
      }
    });
  }

  function altaBoni(id) {
            axios
              .patch(
                `${URL_BONIFICACIONES_RECURRENTES}/${id}`,
                {
                  is_active: "Si"
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
                    Swal.fire("Good job!", "Creado con exito", "success");

                    const newBoniCliente = boniCliente.map((i) => {
                      if (id === i.id) {
                        i.is_active = "Si";
                      }
                      return i;
                    });
                    setBoniCliente(newBoniCliente);
                 
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  // footer: `${error.response.data}`,
                });
                console.log(error);
              });
  }

  function bajaBoni(id) {
    axios
      .patch(
        `${URL_BONIFICACIONES_RECURRENTES}/${id}`,
        {
          is_active: "No"
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem(
              "app_token"
            )}`,
          },
        }
      )
      .then((data) => {
            Swal.fire("Good job!", "Creado con exito", "success");
            const newBoniCliente = boniCliente.map((i) => {
              if (id === i.id) {
                i.is_active = "No";
              }
              return i;
            });
            setBoniCliente(newBoniCliente);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
      });
}

function cue(id, nombre_comercial) {
  setIdClienteCuenta(id);
  setNombreComercial(nombre_comercial);
  axios
    .get(`${URL_CUENTAS_CLIENTES}/cliente/${id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allCuentas = res.data;
      setCuentas(allCuentas);
    })
    .catch((err) => {
      console.log(err);
    });
  toggleCuenta();
}

const handleChangeInputCuentasExistentes = (id, event) => {
  const newCuentas = cuentas.map((i) => {
    if (id === i._id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setCuentas(newCuentas);
};

const handleChangeInputCuentas = (id, event) => {
  const newInputFieldsCuentas = inputFieldsCuentas.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFieldsCuentas(newInputFieldsCuentas);
};

function saveCuenta() {
  let totalCuen = cuentas.length + inputFieldsCuentas.length;
  cuentas.map((a) => {
    if (a.cuenta != "") {
      axios
        .patch(
          `${URL_CUENTAS_CLIENTES}/${a._id}`,
          {
            cuenta: a.cuenta,
            banco: a.banco,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalCuen = totalCuen - 1;
          if (totalCuen == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Cuentas Clientes",
                detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalCuen = totalCuen - 1
      if (totalCuen == 0) {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cuenta Clientes",
            detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  });

  // agregar inputFields
  inputFieldsCuentas.map((a) => {
    if (a.cuenta != "") {
      axios
        .post(
          `${URL_CUENTAS_CLIENTES}`,
          {
            clientes: idClienteCuenta,
            cuenta: a.cuenta,
            banco: a.banco,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalCuen = totalCuen - 1;
          if (totalCuen == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Cuenta Clientes",
                detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalCuen = totalCuen - 1
      if (totalCuen == 0) {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cuenta Clientes",
            detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  });
}

const handleAddFieldsCuentas = () => {
  setInputFieldsCuentas([
    ...inputFieldsCuentas,
    {
      id: uuidv4(),
      banco: "",
      cuenta:"",
    },
  ]);
};

const handleRemoveFieldsCuentas = (id) => {
  const values = [...inputFieldsCuentas];
  values.splice(
    values.findIndex((value) => value.id === id),
    1
  );
  setInputFieldsCuentas(values);
};

function altaCuenta(id) {
  axios
    .patch(
      `${URL_CUENTAS_CLIENTES}/${id}`,
      {
        is_active: "Si"
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }
    )
    .then((data) => {
          Swal.fire("Good job!", "Creado con exito", "success");

          const newCuentas = cuentas.map((i) => {
            if (id === i._id) {
              i.is_active = "Si";
            }
            return i;
          });
          setCuentas(newCuentas);
       
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        // footer: `${error.response.data}`,
      });
      console.log(error);
    });
}

function bajaCuenta(id) {
axios
.patch(
`${URL_CUENTAS_CLIENTES}/${id}`,
{
is_active: "No"
},
{
headers: {
  Authorization: `Bearer: ${localStorage.getItem(
    "app_token"
  )}`,
},
}
)
.then((data) => {
  Swal.fire("Good job!", "Creado con exito", "success");
  const newCuentas = cuentas.map((i) => {
    if (id === i._id) {
      i.is_active = "No";
    }
    return i;
  });
  setCuentas(newCuentas);
})
.catch((error) => {
Swal.fire({
icon: "error",
title: "Oops...",
text: "Something went wrong!",
// footer: `${error.response.data}`,
});
console.log(error);
});
}


function dir(id, nombre_comercial) {
  setIdClienteSucursal(id);
  setNombreComercial(nombre_comercial)
  axios
    .get(`${URL_SUCURSALES}/clientes/${id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allSucursales = res.data;
      setSucursales(allSucursales);
    })
    .catch((err) => {
      console.log(err);
    });
  setAbrirSucursal(true);
}

const handleChangeInputExistentesSuc = (id, event) => {
  const newSucursales = sucursales.map((i) => {
    if (id === i._id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setSucursales(newSucursales);
};

const handleChangeInputSuc = (id, event) => {
  const newInputFields = inputFieldsSuc.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFieldsSuc(newInputFields);
};

// Contactos de una sucursal ya guardada / de una sucursal nueva.
const setContactosSucursal = (id, contactos) =>
  setSucursales((prev) => prev.map((x) => (x._id === id ? { ...x, contactos } : x)));
const setContactosSucursalNueva = (id, contactos) =>
  setInputFieldsSuc((prev) => prev.map((x) => (x.id === id ? { ...x, contactos } : x)));

function saveDireccion() {
  let totalDir = sucursales.length + inputFieldsSuc.length;
  sucursales.map((a) => {
    if (a.alias != "") {
      axios
        .patch(
          `${URL_SUCURSALES}/${a._id}`,
          {
            alias: a.alias,
            calle: a.calle,
            numero_ext: a.numero_ext,
            numero_int: a.numero_int,
            delegacion: a.delegacion,
            estado: a.estado,
            pais: a.pais,
            cp: a.cp,
            colonia: a.colonia,
            ciudad: a.ciudad,
            RFC: a.RFC,
            razon_social: a.razon_social,
            regFiscal: a.regFiscal,
            contactos: contactosParaGuardar(a.contactos)
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalDir = totalDir - 1;
          if (totalDir == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Sucursal",
                detalle: `Cliente ${idClienteSucursal} / Alias ${a.alias}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalDir = totalDir - 1;
    }
  });

  // agregar inputFields
  inputFieldsSuc.map((a) => {
    if (a.alias != "") {
      axios
        .post(
          `${URL_SUCURSALES}`,
          {
            alias: a.alias,
            calle: a.calle,
            numero_ext: a.numero_ext,
            numero_int: a.numero_int,
            delegacion: a.delegacion,
            estado: a.estado,
            pais: a.pais,
            cp: a.cp,
            colonia: a.colonia,
            ciudad: a.ciudad,
            clientes: idClienteSucursal,
            RFC: a.RFC,
            razon_social: a.razon_social,
            regFiscal: a.regFiscal,
            contactos: contactosParaGuardar(a.contactos)
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalDir = totalDir - 1;
          if (totalDir == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Sucursal",
                detalle: `Cliente ${idClienteSucursal} / Alias ${a.alias}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalDir = totalDir - 1;
    }
  });
}

const handleAddFieldsSuc = () => {
  setInputFieldsSuc([
    ...inputFieldsSuc,
    {
      id: uuidv4(),
      alias: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      delegacion: "",
      estado: "",
      pais: "",
      cp: "",
      colonia: "",
      ciudad: "",
      RFC:"",
      razon_social:"",
      regFiscal: "",
      contactos: []
    },
  ]);
};


  return (
    <>
      <Header />
      <br />
      <br />
      {puede(user, "catalogos.clientes.ver") ? (
        <div className="card col-12">
        {!abrirSucursal ? (
          <>
          <Row>
            <Col md={8}>
              {puede(user, "catalogos.clientes.crear") ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/ClientesCreate"
                >
                  Nuevo Cliente
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Cliente
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCatalogos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              {verTaref && (
              <ButtonGroup style={{ marginLeft: 12 }}>
                {[["Si", "Kasher"], ["No", "Taref"], ["", "Todos"]].map(([v, t]) => (
                  <Button key={t} size="sm" color={vistaFiscal === v ? "primary" : "secondary"} outline={vistaFiscal !== v}
                    onClick={() => { setVistaFiscal(v); setCurrentPage(1); }}>
                    {t}
                  </Button>
                ))}
              </ButtonGroup>
              )}
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Clientes</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-user-tie" style={{ marginRight: 8, color: "#3b82f6" }} />
                Clientes
              </h3>
              <p className="page-subtitle">Directorio de clientes</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <div className="filter-bar">
            <div>
              <Label>Zonas</Label>
              <Input
                bsSize="sm"
                type="select"
                value={grupo}
                onChange={(e) => {
                  setGrupo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {grupos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </div>
            <div>
              <Label>Contacto</Label>
              <Input
                bsSize="sm"
                type="select"
                value={contacto}
                onChange={(e) => {
                  setContacto(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </div>
            <div>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </div>
          </div>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => {
                {
                  return (
                    <tr>
                      <td>{p.codigo}</td>
                      <td>{p.nombre_comercial}</td>
                      <td>{p.telefono}</td>
                      <td>{p.email}</td>
                      <td>{p.grupo}</td>
                      <td>{p.contacto}</td>
                      <td>{p.ultimoPedido}</td>
                      <td>{p.ultimoSurtido}</td>
                      <td style={{ minWidth: 140 }}>
                        <Input
                          bsSize="sm"
                          type="date"
                          defaultValue={p.ultimaLlamada}
                          onChange={(e) => guardaLlamada(p._id, "ultimaLlamada", e.target.value)}
                        />
                      </td>
                      <td style={{ minWidth: 140 }}>
                        <Input
                          bsSize="sm"
                          type="date"
                          defaultValue={p.proximaLlamada}
                          onChange={(e) => guardaLlamada(p._id, "proximaLlamada", e.target.value)}
                        />
                      </td>
                      <td>
                          <div>
                            {/* <Button
                              color="dany"
                              size="sm"
                              onClick={(e) => Info(p._id)}
                              id="Detalle"
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button> */}
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => dir(p._id, p.nombre_comercial)}
                            >
                              <i class="fas fa-shipping-fast"></i>
                            </Button>
                            {puede(user, "catalogos.clientes.editar") && (
<Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => {
                                setExtra(p.extra || EXTRA_CLIENTE_VACIO);
                                setFiscal(p.fiscal || "Si");
                                jalaInfo(
                                  p._id,
                                  p.telefono,
                                  p.email,
                                  p.calle,
                                  p.numero_ext,
                                  p.numero_int,
                                  p.pais,
                                  p.estado,
                                  p.ciudad,
                                  p.delegacion,
                                  p.colonia,
                                  p.cp,
                                  p.nombre_comercial,
                                  p.razon_social,
                                  p.RFC,
                                  p.grupo,
                                  p.idGrupo,
                                  p.contacto,
                                  p.idContacto,
                                  p.observaciones,
                                  p.ultimo_pago,
                                  p.forma_pago,
                                  p.usoCFDI, 
                                  p.regFiscal,
                                  p.formaPagoSAT,
                                  p.condicionesPagoSAT,
                                  p.metodoPagoSAT,
                                  p.codigo,
                                  p.plazo,
                                  p.frecuenciaCompra,
                                  p.comprador
                                );
                              }}
                            >
                              <i class="far fa-edit"></i>
                            </Button>
)}

                            {/* <Button
                              color="success"
                              size="sm"
                              onClick={(e) => jalaBoni(p._id, p.nombre_comercial)}
                              id="Detalle"
                            >
                              <i class="fas fa-percentage"></i>
                            </Button> */}

                            <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    cue(p._id, p.nombre_comercial)
                                  }
                                >
                                  <i class="fas fa-dollar-sign"></i>
                                </Button>
                            {puede(user, "catalogos.clientes.editar") && (
<Baja
                              idStatus={p._id}
                              is_active={p.activo}
                              URL_BAJA={process.env.REACT_APP_URL_CLIENTES}
                            />
)}
                          </div>
                      
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
          </>
           ) : (
            <div className="card container col-md-12">
               <h3 align="center">Direccion de Entrega {nombre_comercial}</h3>
              {sucursales.map((ao) => (
            <div key={ao._id}>
              <Row>
                <Col md={2}>
                <Label className="mr-sm-2">Alias</Label>
                  <Input
                    // bsSize="sm"
                    name="alias"
                    type="text"
                    value={ao.alias}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Calle</Label>
                  <Input
                    // bsSize="sm"
                    name="calle"
                    type="text"
                    value={ao.calle}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>

                <Col md={1}>
                <Label className="mr-sm-2"># Ext</Label>
                  <Input
                    // bsSize="sm"
                    name="numero_ext"
                    type="text"
                    value={ao.numero_ext}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2"># Int</Label>
                  <Input
                    // bsSize="sm"
                    name="numero_int"
                    type="text"
                    value={ao.numero_int}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">Pais</Label>
                  <Input
                    // bsSize="sm"
                    name="pais"
                    type="text"
                    value={ao.pais}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Estado</Label>
                  <Input
                    // bsSize="sm"
                    name="estado"
                    type="text"
                    value={ao.estado}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Ciudad</Label>
                  <Input
                    // bsSize="sm"
                    name="ciudad"
                    type="text"
                    value={ao.ciudad}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                </Row>
                <Row>
                <Col md={2}>
                <Label className="mr-sm-2">Delegacion</Label>
                  <Input
                    // bsSize="sm"
                    name="delegacion"
                    type="text"
                    value={ao.delegacion}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Colonia</Label>
                  <Input
                    // bsSize="sm"
                    name="colonia"
                    type="text"
                    value={ao.colonia}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">CP</Label>
                  <Input
                    // bsSize="sm"
                    name="cp"
                    type="text"
                    value={ao.cp}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">RFC</Label>
                  <Input
                    // bsSize="sm"
                    name="RFC"
                    type="text"
                    value={ao.RFC}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Razon Social</Label>
                  <Input
                    // bsSize="sm"
                    name="razon_social"
                    type="text"
                    value={ao.razon_social}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Reg Fiscal</Label>
                  <Input
                    // bsSize="sm"
                    name="regFiscal"
                    type="select"
                    value={ao.regFiscal}
                    required
                    onChange={(event) => {
                      handleChangeInputExistentesSuc(ao._id, event);
                    }}
                    >
                    <option value="">Reg Fiscal</option>
                 <option value="0">0</option>
                 <option value="601">601 General de Ley Personas Morales</option>
                 <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                 <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                 <option value="608">608 Demas Ingresos</option>
                 <option value="612">612 Personas Fisicas con Actividad Empresarial</option>
                 <option value="616">616 Sin Obligacion Fiscal</option>
                 <option value="621">621 Incorporacion Fiscal</option>
                 <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                 <option value="626">626 Regimen simplificado de Confianza</option>
                 </Input>
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">Alta / Baja</Label>
                <br />
                <Baja
                    idStatus={ao._id}
                    is_active={ao.is_active}
                    URL_BAJA={process.env.REACT_APP_URL_SUCURSALES}
                  />
                </Col>
              </Row>
              <div style={{ margin: "8px 0 4px", paddingLeft: 12, borderLeft: "3px solid #e2e8f0" }}>
                <ContactosEditor
                  titulo={`Contactos de ${ao.alias || "la sucursal"}`}
                  contactos={ao.contactos || []}
                  onChange={(c) => setContactosSucursal(ao._id, c)}
                />
              </div>
              <br />
            </div>
          ))}

          {/* Agregar mas direcciones */}

          {inputFieldsSuc.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                <Label className="mr-sm-2">Alias</Label>
                  <Input
                    // bsSize="sm"
                    name="alias"
                    type="text"
                    value={inputField.alias}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>

                <Col md={2}>
                <Label className="mr-sm-2">Calle</Label>
                  <Input
                    // bsSize="sm"
                    name="calle"
                    type="text"
                    value={inputField.calle}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>

                <Col md={1}>
                <Label className="mr-sm-2"># Ext</Label>
                  <Input
                    // bsSize="sm"
                    name="numero_ext"
                    type="text"
                    value={inputField.numero_ext}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2"># Int</Label>
                  <Input
                    // bsSize="sm"
                    name="numero_int"
                    type="text"
                    value={inputField.numero_int}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">Pais</Label>
                  <Input
                    // bsSize="sm"
                    name="pais"
                    type="text"
                    value={inputField.pais}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Estado</Label>
                  <Input
                    // bsSize="sm"
                    name="estado"
                    type="text"
                    value={inputField.estado}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Ciudad</Label>
                  <Input
                    // bsSize="sm"
                    name="ciudad"
                    type="text"
                    value={inputField.ciudad}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                </Row>
                <Row>
                <Col md={2}>
                <Label className="mr-sm-2">Delegacion</Label>
                  <Input
                    // bsSize="sm"
                    name="delegacion"
                    type="text"
                    value={inputField.delegacion}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Colonia</Label>
                  <Input
                    // bsSize="sm"
                    name="colonia"
                    type="text"
                    value={inputField.colonia}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={1}>
                <Label className="mr-sm-2">CP</Label>
                  <Input
                    // bsSize="sm"
                    name="cp"
                    type="text"
                    value={inputField.cp}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">RFC</Label>
                  <Input
                    // bsSize="sm"
                    name="RFC"
                    type="text"
                    value={inputField.RFC}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Razon Social</Label>
                  <Input
                    // bsSize="sm"
                    name="razon_social"
                    type="text"
                    value={inputField.razon_social}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  />
                </Col>
                <Col md={2}>
                <Label className="mr-sm-2">Reg Fiscal</Label>
                  <Input
                    // bsSize="sm"
                    name="regFiscal"
                    type="select"
                    value={inputField.regFiscal}
                    required
                    onChange={(event) => {
                      handleChangeInputSuc(inputField.id, event);
                    }}
                  >
                     <option value="">Reg Fiscal</option>
                  <option value="0">0</option>
                  <option value="601">601 General de Ley Personas Morales</option>
                  <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                  <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                  <option value="608">608 Demas Ingresos</option>
                  <option value="612">612 Personas Fisicas con Actividad Empresarial</option>
                  <option value="616">616 Sin Obligacion Fiscal</option>
                  <option value="621">621 Incorporacion Fiscal</option>
                  <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                  <option value="626">626 Regimen simplificado de Confianza</option>
                  </Input>
                </Col>
                <Col md={1}>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFieldsSuc}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
              <div style={{ margin: "8px 0 4px", paddingLeft: 12, borderLeft: "3px solid #e2e8f0" }}>
                <ContactosEditor
                  titulo="Contactos de la sucursal nueva"
                  contactos={inputField.contactos || []}
                  onChange={(c) => setContactosSucursalNueva(inputField.id, c)}
                />
              </div>
              <br />
            </div>
          ))}
          <Col md={2}>
          <Button size="sm" color="success" onClick={saveDireccion}>
            Guardar
          </Button>
          <Button
                  onClick={(e) => setAbrirSucursal(false)}
                  className="btn btn-danger"
                  id="botonListado"
                  size="sm"
                >
                  Regresar
                </Button>
          </Col>
            </div> 
          )}
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Informacion del Cliente</h4>{" "}
        </ModalHeader>
        <ModalBody>
          <ClientesInfo idCliente={idInfo} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4><i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />Editar cliente {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-id-card" />
              <span className="form-section-title">Datos Generales</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
              <Label>Codigo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigo}
                disabled
              />
            </Col>
            <Col md={3}>
              <Label>Comprador</Label>
              <Input
                type="text"
                placeholder="Comprador"
                value={comprador}
                onChange={(e) => {
                  setComprador(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Nombre Comercial</Label>
              <Input
                type="text"
                placeholder="Nombre Comercial"
                value={nombre_comercial}
                required
                onChange={(e) => {
                  setNombreComercial(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Razon Social</Label>
              <Input
                type="text"
                placeholder="Razon Social"
                value={razon_social}
                required
                onChange={(e) => {
                  setRazonSocial(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>RFC</Label>
              <Input
                type="text"
                placeholder="RFC"
                value={RFC}
                required
                onChange={(e) => {
                  setRFC(e.target.value);
                }}
              />
            </Col>
          </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-map-marker-alt" />
              <span className="form-section-title">Dirección</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={8}>
              <Label>Calle</Label>
              <Input
                type="text"
                placeholder="Calle"
                value={calle}
                required
                onChange={(e) => {
                  setCalle(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Ext</Label>
              <Input
                type="text"
                placeholder="No. Ext"
                value={numero_ext}
                required
                onChange={(e) => {
                  setNumeroExt(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Int</Label>
              <Input
                type="text"
                placeholder="No. Int"
                value={numero_int}
                required
                onChange={(e) => {
                  setNumeroInt(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Pais</Label>
              <Input
                type="text"
                placeholder="Pais"
                value={pais}
                required
                onChange={(e) => {
                  setPais(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Estado</Label>
              <Input
                type="text"
                placeholder="Estado"
                value={estado}
                required
                onChange={(e) => {
                  setEstado(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Ciudad</Label>
              <Input
                type="text"
                placeholder="Ciudad"
                value={ciudad}
                required
                onChange={(e) => {
                  setCiudad(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Delegacion</Label>
              <Input
                type="text"
                placeholder="Delegacion o Municipio"
                value={delegacion}
                required
                onChange={(e) => {
                  setDelegacion(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Colonia</Label>
              <Input
                type="text"
                placeholder="Colonia"
                value={colonia}
                required
                onChange={(e) => {
                  setColonia(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>CP</Label>
              <Input
                type="text"
                placeholder="CP"
                value={cp}
                required
                onChange={(e) => {
                  setCP(e.target.value);
                }}
              />
            </Col>
          </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-address-book" />
              <span className="form-section-title">Contacto</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
              <Label>Telefono</Label>
              <Input
                type="text"
                placeholder="Telefono"
                value={telefono}
                required
                onChange={(e) => {
                  setTelefono(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Email</Label>
              <Input
                type="text"
                placeholder="Email (varios separados por ;)"
                value={email}
                required
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Zona</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedGrupoEdit}
                required
                onChange={(e) => {
                  setSelectedGrupoEdit(e.target.value);
                }}
              >
                <option value="">Selecciona una Zona</option>
                {grupos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={3}>
              <Label className="mr-sm-2">Contacto Interno</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedContacto}
                required
                onChange={(e) => {
                  setSelectedContacto(e.target.value);
                }}
              >
                <option value="">Selecciona un Contacto</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
</Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-file-invoice" />
              <span className="form-section-title">Fiscal y Pago</span>
            </div>
            <div className="form-section-body">
            {verTaref && (
            <>
            <Row>
              <Col md={3}>
                <Label>Fiscal (Kasher / Taref)</Label>
                <Input type="select" value={fiscal} onChange={(e) => setFiscal(e.target.value)}>
                  <option value="Si">Sí — Kasher (con factura)</option>
                  <option value="No">No — Taref (sin factura)</option>
                </Input>
              </Col>
            </Row>
            <br />
            </>
            )}
<Row>
            <Col md={3}>
              <Label>Forma de Pago</Label>
              <Input
                type="select"
                placeholder="Forma de Pago"
                value={forma_pago}
                required
                onChange={(e) => {
                  setFormaPago(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Efectivo">Efectivo</option>
                <option value="Deposito">Deposito</option>
                <option value="Cheque">Cheque</option>
                <option value="PorDefinir">Por Definir</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Plazo</Label>
              <Input
                type="number"
                min={0}
                placeholder="Días de crédito"
                value={plazo}
                onChange={(e) => {
                  setPlazo(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Frecuencia de Compra (días)</Label>
              <Input
                type="number"
                placeholder="Cada cuántos días compra"
                value={frecuenciaCompra}
                onChange={(e) => {
                  setFrecuenciaCompra(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
                <Label>Regimen Fiscal</Label>
                <Input
                  type="select"
                  placeholder="RegFiscal"
                  value={regFiscal}
                  required
                  onChange={(e) => {
                    setRegFiscal(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="601">601 General de Ley Personas Morales</option>
                  <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                  <option value="605">605 Sueldos y Salarios e Ingresos Asimilados a Salarios</option>
                  <option value="606">606 Arrendamiento</option>
                  <option value="607">607 Régimen de Enajenación o Adquisición de Bienes</option>
                  <option value="608">608 Demás ingresos</option>
                  <option value="610">610 Residentes en el Extranjero sin Establecimiento Permanente en México</option>
                  <option value="611">611 Ingresos por Dividendos (socios y accionistas)</option>
                  <option value="612">612 Personas Físicas con Actividades Empresariales y Profesionales</option>
                  <option value="614">614 Ingresos por intereses</option>
                  <option value="615">615 Régimen de los ingresos por obtención de premios</option>
                  <option value="616">616 Sin obligaciones fiscales</option>
                  <option value="620">620 Sociedades Cooperativas de Producción que optan por diferir sus ingresos</option>
                  <option value="621">621 Incorporación Fiscal</option>
                  <option value="622">622 Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras</option>
                  <option value="623">623 Opcional para Grupos de Sociedades</option>
                  <option value="624">624 Coordinados</option>
                  <option value="625">625 Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas</option>
                  <option value="626">626 Régimen Simplificado de Confianza</option>
                </Input>
              </Col>

              </Row>
              <Row>
              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Uso de CDFI
                </Label>
                <Input
                  type="select"
                  placeholder="Uso de CDFI"
                  value={usoCFDI}
                  required
                  onChange={(e) => {
                    setusoCFDI(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="G01">G01 Adquisición de mercancías</option>
                  <option value="G02">G02 Devoluciones, descuentos o bonificaciones</option>
                  <option value="G03">G03 Gastos en general</option>
                  <option value="I01">I01 Construcciones</option>
                  <option value="I02">I02 Mobiliario y equipo de oficina por inversiones</option>
                  <option value="I03">I03 Equipo de transporte</option>
                  <option value="I04">I04 Equipo de cómputo y accesorios</option>
                  <option value="I05">I05 Dados, troqueles, moldes, matrices y herramental</option>
                  <option value="I06">I06 Comunicaciones telefónicas</option>
                  <option value="I07">I07 Comunicaciones satelitales</option>
                  <option value="I08">I08 Otra maquinaria y equipo</option>
                  <option value="D01">D01 Honorarios médicos, dentales y gastos hospitalarios</option>
                  <option value="D02">D02 Gastos médicos por incapacidad o discapacidad</option>
                  <option value="D03">D03 Gastos funerales</option>
                  <option value="D04">D04 Donativos</option>
                  <option value="D05">D05 Intereses reales por créditos hipotecarios (casa habitación)</option>
                  <option value="D06">D06 Aportaciones voluntarias al SAR</option>
                  <option value="D07">D07 Primas por seguros de gastos médicos</option>
                  <option value="D08">D08 Gastos de transportación escolar obligatoria</option>
                  <option value="D09">D09 Depósitos en cuentas de ahorro, primas de planes de pensiones</option>
                  <option value="D10">D10 Pagos por servicios educativos (colegiaturas)</option>
                  <option value="S01">S01 Sin efectos fiscales</option>
                  <option value="CP01">CP01 Pagos</option>
                  <option value="CN01">CN01 Nómina</option>
                  </Input>
              </Col>
              <Col md={3}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  type="select"
                  value={formaPagoSAT}
                  required
                  onChange={(e) => {
                    setFormaPagoSAT(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label>Metodo Pago Fiscal</Label>
                <Input
                  type="select"
                  value={metodoPagoSAT}
                  required
                  onChange={(e) => {
                    setMetodoPagoSAT(e.target.value);
                  }}
                >

              <option value="">Selecciona</option>
              <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
              <option value="PPD">PPD (Pago en Parcialidades o Diferido)</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label>Condiciones de Pago Fiscal</Label>
                <Input
                  type="text"
                  value={condicionesPagoSAT}
                  required
                  onChange={(e) => {
                    setCondicionesPagoSAT(e.target.value);
                  }}
                />
              </Col>
            </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-comment-alt" />
              <span className="form-section-title">Observaciones</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-address-book" />
              <span className="form-section-title">Datos Adicionales y Contactos (opcional)</span>
            </div>
            <div className="form-section-body">
              <DatosAdicionalesCliente extra={extra} setExtra={setExtra} />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editClientes}>
            <i className="fas fa-save" style={{ marginRight: 6 }} />Guardar
          </Button>
        </ModalFooter>
      </Modal>


      <Modal size="xl" isOpen={modalBoni} toggle={toggleBoni}>
        <ModalHeader toggle={toggleBoni}>
          <h4>Bonificaciones {clienteBoniName}</h4>
        </ModalHeader>
        <ModalBody>
        <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Concepto</th>
                      <th>Fijo</th>
                      <th>Porcentaje</th>
                      {/* <th>Importe</th> */}
                      <th>Observaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {boniCliente.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="date"
                            name="fecha"
                            value={a.fecha}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="concepto"
                            type="select"
                            value={a.concepto}
                            required
                            onChange={(event) => {
                              handleChangeInputExistentes(a.id, event);
                            }}
                          >
                            <option value="">Selecciona</option>
                            {conceptosBonificaciones.map((cb) => {
                              return (
                              <option value={cb._id}>{cb.name}</option>
                              )
                            })}
                          </Input>
                        </td>
                        <td>
                          <Input
                            type="select"
                            name="fijo"
                            value={a.fijo}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          >
                            <option value="">Selecciona</option>
                            <option value="Si">Si</option>
                            <option value="No">No</option>
                            </Input>
                        </td>
                        <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="porcentaje"
                            value={a.porcentaje}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          />
                        </td>
                        {/* <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="importe"
                            value={a.importe}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          />
                        </td> */}
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputExistentes(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          {a.is_active == "Si"?(
                            <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={() => bajaBoni(a.id)}
                            tabindex="-1"
                          >
                            <i class="far fa-times-circle"></i>
                          </Button>
                          ):(
                            <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={() => altaBoni(a.id)}
                            tabindex="-1"
                          >
                            <i class="far fa-check-circle"></i>
                          </Button>
                          )}
                         
                        </td>
                      </tr>
                      // </div>
                    ))}

              {inputFields.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="date"
                            name="fecha"
                            value={a.fecha}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="concepto"
                            type="select"
                            value={a.concepto}
                            required
                            onChange={(event) => {
                              handleChangeInput(a.id, event);
                            }}
                          >
                            <option value="">Selecciona</option>
                            {conceptosBonificaciones.map((cb) => {
                              return (
                              <option value={cb._id}>{cb.name}</option>
                              )
                            })}
                          </Input>
                        </td>
                        <td>
                          <Input
                            type="select"
                            name="fijo"
                            value={a.fijo}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          >
                            <option value="">Selecciona</option>
                            <option value="Si">Si</option>
                            <option value="No">No</option>
                            </Input>
                        </td>
                        <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="porcentaje"
                            value={a.porcentaje}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td>
                        {/* <td>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            name="importe"
                            value={a.importe}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td> */}
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            disabled={inputFields.length === 1}
                            onClick={() => handleRemoveFields(a.id)}
                            tabindex="-1"
                          >
                            <i class="fas fa-minus"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFields}
                            tabindex="-1"
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </td>
                      </tr>
                      // </div>
                    ))}

                  </tbody>
                  <br />
                </Table>
                <br />
                <Row>
                <Button className="btn btn-success" onClick={saveBoni}>
                Registrar
              </Button>
                </Row>

        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal size="xl" isOpen={modalCuenta} toggle={toggleCuenta}>
        <ModalHeader toggle={toggleCuenta}>
          <h4>Cuentas {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
        <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Banco</th>
                      <th>Cuentas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cuentas.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="text"
                            name="banco"
                            value={a.banco}
                            key={a._id}
                            onChange={(e) => {
                              handleChangeInputCuentasExistentes(a._id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="cuenta"
                            type="text"
                            value={a.cuenta}
                            required
                            maxLength="4" // Limit to 4 digits
                            pattern="\d{1,4}" 
                            onChange={(event) => {
                              handleChangeInputCuentasExistentes(a._id, event);
                            }}
                          />
                        </td>
                        <td>
                          {a.is_active == "Si"?(
                            <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={() => bajaCuenta(a._id)}
                            tabindex="-1"
                          >
                            <i class="far fa-times-circle"></i>
                          </Button>
                          ):(
                            <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={() => altaCuenta(a._id)}
                            tabindex="-1"
                          >
                            <i class="far fa-check-circle"></i>
                          </Button>
                          )}
                         
                        </td>
                      </tr>
                      // </div>
                    ))}

              {inputFieldsCuentas.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="text"
                            name="banco"
                            value={a.banco}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputCuentas(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="cuenta"
                            type="text"
                            value={a.cuenta}
                            required
                            maxLength="4" // Limit to 4 digits
                            pattern="\d{1,4}" 
                            onChange={(event) => {
                              handleChangeInputCuentas(a.id, event);
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            disabled={a.length === 1}
                            onClick={() => handleRemoveFieldsCuentas(a.id)}
                            tabindex="-1"
                          >
                            <i class="fas fa-minus"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFieldsCuentas}
                            tabindex="-1"
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </td>
                      </tr>
                      // </div>
                    ))}

                  </tbody>
                  <br />
                </Table>
                <br />
                <Row>
                <Button className="btn btn-success" onClick={saveCuenta}>
                Registrar
              </Button>
                </Row>

        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoClientes;
